import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
// import InfoChartMap from './InfoChartMap';
import NoDataDialog from './NoDataDialog';
import { reportReset } from '../actions/index';
import InfoChartMap from './InfoChartMap';
import useLoadCustomReport from '../hooks/useLoadCustomReport';

const CustomReportView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { viewName } = useParams();
  const data = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      type: 'custom-report',
      objectId: queryParams.get('object'),
      start: moment(queryParams.get('start')),
      end: moment(queryParams.get('end')),
      customType: queryParams.get('type'),
    };
  }, [location.search]);

  // const hasMissingParams = !data.objectId || !data.start || !data.end;

  const loadReport = useLoadCustomReport(data);

  React.useEffect(() => {
    if (viewName === 'custom-report') {
      loadReport.loadAsync().then(() => {
        // Report loaded successfully
      });
    }
    return () => loadReport.controller.abort();
  }, [loadReport, viewName]);

  const onConfirm = () => {
    history.goBack();
    dispatch(reportReset('custom-report'));
  };
  const customReport = useSelector(state => state.report['custom-report']);
  const errorDialog = customReport.status === 'nodata';
  const reportType =
    customReport.status === 'nodata' || customReport.status === 'loading'
      ? 'loading'
      : 'custom';

  return (
    <React.Fragment>
      {errorDialog && (
        <NoDataDialog
          open={true}
          onClose={onConfirm}
          objectName={customReport.objectName}
          startDate={customReport.start}
          endDate={customReport.end}
        />
      )}
      <InfoChartMap object={customReport} type={reportType} />
    </React.Fragment>
  );
};

export default CustomReportView;
